module.exports = __webpack_public_path__ + "img/buddy_nose-01.15727422.svg";